import store from '../../../../store';
import MybetsTabsService from '../../../../services/mybets/mybets-tabs-service';
import MybetsRequestService from '../../../../services/mybets-service';
import MybetDetailsRequestService from '../../../../services/mybets/mybet-details-request-service';
import MyBetDetailsModel from '../../../../models/mybets/model-mybet-details.js';
import { EmptyState, ICON_CLASS } from '../../empty-state';
import { userLoggedIn } from '@bto-services/user';
import { useCashoutV2tCalculation } from '@bto-services/api/shared/sb-settings';

export default {
  components: {
    EmptyState,
  },
  data() {
    return {
      myBets: [],
      activeTab: {},
      isLoading: false,
      currentPage: 1,
      pageSize: 5,
      emptyStateIcon: ICON_CLASS.MYBETS,
      infoMsg: 'M.MyBetsEmpty',
    };
  },
  mounted() {
     useCashoutV2tCalculation().then( val => {
       if (val && userLoggedIn()) {
        this.$root.signalrRequest.connectToCashoutHubStartCalc();
       }
     })
    
  },
  beforeDestroy() {
    useCashoutV2tCalculation().then( val => {
      if (val && userLoggedIn()) {
        this.$root.signalrRequest.disconnectFromCashoutHubStopCalc();
      }
    })
  },
  methods: {
    changeTab(tab) {
      if (this.activeTab === tab) {
        return;
      }
      this.betSlipSearch = null;
      this.activeTab = tab;
      this.reset();
      this.getHistory();
    },
    checkStatus(bet, status) {
      return bet.betSlipGroupStatusId === status;
    },
    getCashout(bet) {
      return store.getters.getCashoutByBetslipGroupId(bet.betSlipGroupID);
    },
    /**
     * Get mybets details from api
     * @param {number} betId betSlipGroupID 
     * @param {boolean} showLoading show loading when we search for signle betslip
     */
    getDetails(betId, showLoading) {
      const bhIndex = this.myBets.findIndex(mb => mb.betDetails && mb.betSlipGroupID === betId);
      if (bhIndex !== -1) {
        this.$set(this.myBets, bhIndex, { ...this.myBets[bhIndex], isVisible: !this.myBets[bhIndex].isVisible });
        return;
      }
      let request = new MybetDetailsRequestService();
      request.getParams.betSlipGroupID = betId;

      if (showLoading) {
        this.isLoading = true;
      }
      request.execute((resp) => {
        if (showLoading) {
          this.resetLoading();
          if (resp.data.g === null || resp.data.g.i === null) {
            this.myBets = [];
            return;
          }
        }
        // if api return null set noDetailsData to true to show no details info message
        if (resp.data.g === null || resp.data.g.i === null) {
          this.myBets = this.myBets.map(mb => (mb.betSlipGroupID === betId) ? {
            ...mb,
            isVisible: true,
            betDetails: true,
            noDetailsData: true,
          } : mb);
          return;
        }
        const details = new MyBetDetailsModel(resp.data);
        this.myBets = this.myBets.map(mb => (mb.betSlipGroupID === betId) ? {
          ...mb,
          ...details,
          isVisible: true,
          betDetails: true,
        } : mb);
      }, this.resetLoading);
    },
    getBaseMybetsRequestService() {
      let request = new MybetsRequestService();
      const status = this.getStatusCodes();
      request.getParams.status = status;
      request.getParams.items = this.pageSize;
      request.getParams.page = this.currentPage;

      return request;
    },
    getStatusCodes() {
      if (this.activeTab.code === -1) {
        return MybetsTabsService.getOrderedTabCodes();
      }
      if (this.activeTab.tabCodes) {
        return this.activeTab.tabCodes;
      }
      return [this.activeTab.code];
    },
    resetLoading() {
      this.isLoading = false;
    },
    reset() {
      this.currentPage = 1;
      this.myBets = [];
    },
  },
};